import { createFileRoute } from '@tanstack/react-router'
import { requireAuth } from '@/common/routes/requireAuth'
import { useOrganization } from '@/pages/organizations/detail'
import Team from '@/pages/organizations/detail/team'

export const Route = createFileRoute('/app/organizations/$organizationId/team')({
  beforeLoad: ({ context }) => {
    requireAuth(context)
  },
  component: RouteComponent,
})

function RouteComponent() {
  const { organization } = useOrganization()
  return <Team organization={organization} />
}
